import { Building2 } from "lucide-react";

const PARTNERS = [
  { name: "Hilton Resorts", tier: "Lead Vocational Partner", category: "Hospitality" },
  { name: "City of North Myrtle Beach", tier: "Municipal Partner", category: "Government" },
  { name: "Horry County Workforce", tier: "Workforce Pipeline", category: "Public Agency" },
  { name: "NCCER", tier: "Certifying Body", category: "Trades Certification" },
  { name: "South Carolina Works", tier: "Funding Partner", category: "State Agency" },
  { name: "Local Construction Guilds", tier: "Trade Employers", category: "Trades Network" },
];

export default function PartnersBand() {
  return (
    <section
      id="partners"
      data-testid="partners-section"
      className="relative bg-[#FAFAF7] py-24 sm:py-28 border-b border-[#E8E5DA]"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-7">
            <div className="font-mono text-[11px] tracking-[0.28em] uppercase text-[#C9A227] mb-4 flex items-center gap-3">
              <span className="h-px w-8 bg-[#C9A227]" /> §03 · Strategic Partners
            </div>
            <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.98] text-[#0A0612]">
              Trusted by the partners
              <br />
              <span className="italic font-medium text-[#6B6F76]">that put people to work.</span>
            </h2>
          </div>
          <div className="lg:col-span-4 lg:col-start-9 lg:pt-3">
            <p className="text-base leading-relaxed text-[#0A0612]/75">
              The Alliance only works because municipalities, employers, and certifying
              bodies stake their reputation alongside ours in serving the Last, the Least
              and the Lost.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E8E5DA] border border-[#E8E5DA]">
          {PARTNERS.map((p) => (
            <div key={p.name} data-testid={`partner-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="bg-white p-6 sm:p-7 hover:bg-[#FBF8EE] transition-colors group">
              <div className="flex items-start justify-between mb-4">
                <Building2 className="h-5 w-5 text-[#C9A227]" strokeWidth={1.5} />
                <div className="font-mono text-[9px] tracking-[0.22em] uppercase text-[#6B6F76]">
                  {p.category}
                </div>
              </div>
              <h3 className="font-display font-semibold text-xl tracking-tight text-[#0A0612] mb-2">
                {p.name}
              </h3>
              <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#C9A227]">
                {p.tier}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="font-display italic text-lg text-[#0A0612]/70">
            Want to put your company's logo here?
          </div>
          <a href="#assist" data-testid="partners-cta"
            className="font-mono text-[11px] tracking-[0.22em] uppercase text-[#0A0612] hover:text-[#C9A227] border-b-2 border-[#C9A227] pb-1 self-start">
            Become an Employer Partner →
          </a>
        </div>
      </div>
    </section>
  );
}
